import { useRef, useState } from 'react';

export const useDragToScroll = () => {
    const [startDragX, setStartDragX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const containerRef = useRef(null);

    const onMouseDown = e => {
        e.preventDefault();
        setStartDragX(e.pageX);
    };

    const onMouseMove = e => {
        if (startDragX !== 0) {
            const x = e.pageX;
            const scrollDiff = (startDragX - x) * 2;
            const scrollElement = containerRef.current;
            if (scrollElement) {
                scrollElement.scrollLeft += scrollDiff;
                setScrollLeft(scrollElement.scrollLeft);
                setStartDragX(x);
            }
        }
    };

    const onMouseLeaveOrUp = () => {
        setStartDragX(0);
    };

    return {
        containerRef,
        onMouseDown,
        onMouseMove,
        onMouseLeaveOrUp,
        scrollLeft,
    };
};
